export default __webpack_public_path__ + "static/media/animTraining.d408f386.png";